import Vue from 'vue'
import Router from 'vue-router'

// Authentication & Onboarding
import Welcome from './views/Welcome'
import AuthLogin from './views/auth/Login.vue'
import AuthRegister from './views/auth/Register.vue'
import AuthRegisterCalendar from './views/auth/RegisterCalendar.vue'
import AuthRegisterSchedule from './views/auth/RegisterSchedule.vue'
import AuthForgotPassword from './views/auth/ForgotPassword.vue'
import AuthResetPassword from './views/auth/ResetPassword.vue'

// User Profile
import ProfileEditProfile from './views/profile/EditProfile.vue'
import ProfileEditCalendar from './views/profile/EditCalendar.vue'

// Entrepreneur & Advisor User Views
import UsersAdvisorsList from './views/users/AdvisorsList.vue'
import UsersEntrepreneursList from './views/users/EntrepreneursList.vue'
import UsersProfile from './views/users/Profile.vue'

// Meetings
import MeetingsConfirm from './views/meetings/Confirmation.vue'
import MeetingsList from './views/meetings/List.vue'

// Reviews
import ReviewsList from './views/reviews/List.vue'
import ReviewsAdd from './views/reviews/Add.vue'

// Admin
import AdminDashboard from './views/admin/Dashboard.vue'
import AdminUsers from './views/admin/Users.vue'
import AdminEditUser from './views/admin/users/Edit.vue'
import AdminMeetings from './views/admin/Meetings.vue'
import AdminReviews from './views/admin/Reviews.vue'
import AdminResources from './views/admin/EducationalResources.vue'

import ResourcesList from './views/resources/List.vue'
import ResourceDetail from "./views/resources/Detail.vue";
import EditResource from './views/admin/educational_resources/Edit'

// Dashboard
import Dashboard from './views/Dashboard.vue'

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },

    // --- Auth ---
    {
      path: '/login',
      name: 'AuthLogin',
      component: AuthLogin,
      meta: {
        auth: false
      }
    },
    {
      path: '/forgot-password',
      name: 'AuthForgotPassword',
      component: AuthForgotPassword,
      meta: {
        auth: false
      }
    },
    {
      path: '/reset-password',
      name: 'AuthResetPassword',
      component: AuthResetPassword,
      meta: {
        auth: false
      }
    },
    {
      path: '/register',
      name: 'AuthRegister',
      component: AuthRegister,
      meta: {
        auth: false
      }
    },
    {
      path: '/register/calendar',
      name: 'AuthRegisterCalendar',
      component: AuthRegisterCalendar,
      meta: {
        auth: true
      }
    },
    {
      path: '/register/schedule',
      name: 'AuthRegisterSchedule',
      component: AuthRegisterSchedule,
      meta: {
        auth: true
      }
    },

    // --- Profile ---
    {
      path: '/calendar',
      name: 'ProfileEditCalendar',
      component: ProfileEditCalendar,
      meta: {
        auth: true
      }
    },
    {
      path: '/profile/edit',
      name: 'ProfileEditProfile',
      component: ProfileEditProfile,
      meta: {
        auth: true
      }
    },

    // --- Users ---
    {
      path: '/advisors',
      name: 'UsersAdvisorsList',
      component: UsersAdvisorsList,
      meta: {
        auth: true
      }
    },
    {
      path: '/entrepreneurs',
      name: 'UsersEntrepreneursList',
      component: UsersEntrepreneursList,
      meta: {
        auth: true
      }
    },
    {
      path: '/user/:uuid',
      name: 'UsersProfile',
      component: UsersProfile,
      meta: {
        auth: true
      }
    },

    // --- Meetings ---
    {
      path: '/meetings',
      name: 'MeetingsList',
      component: MeetingsList,
      meta: {
        auth: true
      }
    },
    {
      path: '/meeting/:uuid',
      name: 'MeetingsConfirm',
      component: MeetingsConfirm,
      meta: {
        auth: true
      }
    },

    // --- Reviews ---
    {
      path: '/reviews',
      name: 'ReviewsList',
      component: ReviewsList,
      meta: {
        auth: true
      }
    },
    {
      path: '/reviews/:uuid',
      name: 'ReviewsAdd',
      component: ReviewsAdd,
      meta: {
        auth: true
      }
    },

    // --- Educational Resources ---
    {
      path: '/resources',
      name: 'ResourcesList',
      component: ResourcesList,
      meta: {
        auth: true
      }
    },
    {
      path: '/resources/create',
      name: 'UserCreateResource',
      component: EditResource,
      meta: {
        auth: true
      }
    },
    {
      path: '/resources/:uuid',
      name: 'ResourceDetail',
      component: ResourceDetail,
      meta: {
        auth: true
      }
    },
    {
      path: '/resources/:uuid/edit',
      name: 'UserEditResource',
      component: EditResource,
      meta: {
        auth: true
      }
    },

    // --- Admin ---
    {
      path: '/admin',
      name: 'AdminDashboard',
      component: AdminDashboard,
      meta: {
        auth: { roles: 'admin' }
      }
    },
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: AdminUsers,
      meta: {
        auth: { roles: 'admin' }
      }
    },
    {
      path: '/admin/users/:uuid',
      name: 'AdminEditUser',
      component: AdminEditUser,
      meta: {
        auth: { roles: 'admin' }
      }
    },
    {
      path: '/admin/meetings',
      name: 'AdminMeetings',
      component: AdminMeetings,
      meta: {
        auth: { roles: 'admin' }
      }
    },
    {
      path: '/admin/reviews',
      name: 'AdminReviews',
      component: AdminReviews,
      meta: {
        auth: { roles: 'admin' }
      }
    },
    {
      path: '/admin/resources',
      name: 'AdminResources',
      component: AdminResources,
      meta: {
        auth: { roles: 'admin' }
      }
    },
    {
      path: '/admin/resources/create',
      name: 'AdminCreateResource',
      component: EditResource,
      meta: {
        auth: { roles: 'admin' }
      }
    },
    {
      path: '/admin/resources/:uuid/edit',
      name: 'AdminEditResource',
      component: EditResource,
      meta: {
        auth: { roles: 'admin' }
      }
    },
    // --- Dashboard ---
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: true
      }
    }
  ]
})

if (process.env.VUE_APP_SKIN === 'fivenomics') {
  router.addRoutes([
    // --- Marketing ---
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome,
      meta: {
        layout: 'empty'
      }
    }])
}

Vue.use(Router)
Vue.router = router

export default router
